module.exports = __webpack_public_path__ + "img/parent-child1.b003376f.jpg";